import React, { useCallback, useState } from 'react';
import { Col, Row } from 'antd';
import './styles.scss';
import { MyModal } from 'components/Atoms';
import { MyButton } from 'components/Atoms';
import * as routePath from 'routers/route-path';
import { useHistory } from 'react-router-dom';
import { getPartnerTier } from 'utilities/agencyPartnerHelper';
import { FormattedMessage } from 'react-intl';
import { useBranding } from 'hooks/useBranding';
import { lowerCase, upperCase } from 'lodash';
import { t } from 'utilities/lang';

const ModalCongratulation = ({
  partnerTierInfo,
  partnerTierLogo,
  visible,
  onClose,
}) => {
  const { getTierName } = useBranding();
  const tierName = getTierName(partnerTierInfo?.partnerProgram?.partnerTier);
  const history = useHistory();

  const handleClose = useCallback(() => {
    onClose();
  }, []);

  const handleGoToDashboard = useCallback(() => {
    handleClose();
    history.push(routePath.PROFILE);
  });

  return (
    <MyModal
      width={650}
      visible={visible}
      onClose={handleClose}
      classNameModal="modal-congratulation"
    >
      <Row>
        <Col span={24}>
          <div className="modal-congratulation__content">
            <div className="text-center">
              <img
                src={partnerTierLogo}
                alt="Tier Logo"
                className="w-100 h-100"
              />
            </div>
            <div>
              <div className="modal-congratulation__title fz-24 fw-600 text-center">
                <FormattedMessage
                  id="modal_congratulation.title"
                  values={{
                    tier: t(`modal_tier_benefit.${lowerCase(tierName)}`),

                    span: (tier) => {
                      return (
                        <span
                          className={`partner-text partner-text--${getPartnerTier(
                            partnerTierInfo
                          )}`}
                        >
                          {upperCase(tier)}
                        </span>
                      );
                    },
                  }}
                />
              </div>

              <div className="text-center mt-15">
                <FormattedMessage id="modal_congratulation.description" />
              </div>
            </div>

            <div className="text-center">
              <MyButton
                onClick={handleGoToDashboard}
                className="btn-primary-custom"
              >
                <FormattedMessage id="modal_congratulation.button_dashboard" />
              </MyButton>
            </div>
          </div>
        </Col>
      </Row>
    </MyModal>
  );
};

export default ModalCongratulation;
